import { Box } from '@mui/system';
import { styled as muiStyled } from '@mui/material/styles';

export const InfoContainer = muiStyled(Box)(({ theme }) => {
  return {
    background: theme.palette.background.paper,
    border: `1px solid #e5e9ee`,
    borderRadius: theme.spacing(1.5),
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
    width: '100%',
  };
});
